import axios from "axios";
import {
  getCurrentQuarterDates,
  // getFirstDayOfPastThreeMonth,
  // getLastDateOfCurrentMonth,
} from "@components/Common/Function";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getTeamsSopApi = async (SH_Code__c, Title) => {
  const currentQuaretrDate = getCurrentQuarterDates();
  const currentQuarterFirstDate = currentQuaretrDate[0];
  const currentQuarterLastDate = currentQuaretrDate[1];

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/teams/get-teams-sop`,
    method: "post",
    headers: headers,
    data: {
      currentQuarterFirstDate,
      currentQuarterLastDate,
      SH_Code__c,
      Title,
    },
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
